import { IApplicationState } from '@store'
import { IFacebookAdAccount } from '../types'

export const selectAdAccounts = (state: IApplicationState): ReadonlyArray<IFacebookAdAccount> =>
  state.facebookAds.accounts
